import BaseInAppOffersService from './BaseInAppOffersService';

export default class WebInAppOffersService extends BaseInAppOffersService {
  protected async _fetchPurchasedId() {}
}
